var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1527_1884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.433 2.04582C18.7556 1.73872 19.1849 1.56895 19.6302 1.57231C20.0756 1.57568 20.5022 1.75194 20.8201 2.06388C21.138 2.37582 21.3223 2.79906 21.334 3.24427C21.3458 3.68949 21.1842 4.12187 20.8832 4.45018L11.7466 15.8766C11.5895 16.0458 11.3999 16.1816 11.1891 16.2759C10.9783 16.3702 10.7507 16.4209 10.5198 16.4252C10.289 16.4295 10.0596 16.3872 9.84548 16.3008C9.63135 16.2144 9.43683 16.0857 9.27357 15.9224L3.21458 9.86343C3.04585 9.7062 2.91051 9.5166 2.81664 9.30593C2.72278 9.09527 2.6723 8.86785 2.66824 8.63726C2.66417 8.40666 2.70659 8.17761 2.79296 7.96376C2.87934 7.74991 3.0079 7.55565 3.17098 7.39257C3.33407 7.22949 3.52832 7.10093 3.74217 7.01455C3.95602 6.92817 4.18507 6.88576 4.41567 6.88982C4.64626 6.89389 4.87368 6.94437 5.08434 7.03823C5.29501 7.1321 5.48461 7.26743 5.64184 7.43617L10.4368 12.2289L18.3895 2.09619C18.4039 2.07856 18.4169 2.06175 18.433 2.04582Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1527_1884",
    x: 0.767969,
    y: 0.572266,
    width: 22.667,
    height: 18.8535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.488333 0 0 0 0 0.111445 0 0 0 0 0.095632 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1527_1884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1527_1884",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon2);
export default __webpack_public_path__ + "static/media/check_icon2.6d9a88f2a9fe0ca5de1280a61ccf83e4.svg";
export { ForwardRef as ReactComponent };